<template>
  <div>
    <h2 v-if="busy">loading...</h2>

    <UserCreator @success="setActive" @editView="editView" @editDone="editDone" @login="routeLogin" step="1"
                 v-bind:active="activeStep === 'UserCreator'"></UserCreator>
    <AddressCreator @success="setActive" @editView="editView" @editDone="editDone" step="2"
                    v-bind:active="activeStep === 'AddressCreator'"></AddressCreator>
    <PaymentMethodCreator @success="setActive" @editView="editView" @editDone="editDone" step="3"
                          v-bind:active="activeStep === 'PaymentMethodCreator'"></PaymentMethodCreator>
    <Review @success="setActive" @editView="editView" @editDone="editDone" step="4"
            v-bind:active="activeStep === 'Review'"></Review>
  </div>
</template>

<script>
  import UserCreator from './account/UserCreator';
  import PaymentMethodCreator from './payment/PaymentMethodCreator';
  import AddressCreator from './address/AddressCreator';
  import Review from './review/Review';

  export default {
    name: 'Steps',
    components: {
      UserCreator,
      PaymentMethodCreator,
      AddressCreator,
      Review,
    },
    data() {
      return {
        busy: false,
        activeStep: 'UserCreator',
        incompleteStep: 'UserCreator',
      };
    },
    methods: {
      setActive() {
        let res;
        switch (this.activeStep) {
          case 'UserCreator':
            res = 'AddressCreator';
            break;
          case 'AddressCreator':
            res = 'PaymentMethodCreator';
            break;
          case 'PaymentMethodCreator':
            res = 'Review';
            break;
          case 'Review':
            this.$emit('success');
            break;
          default:
          // do nothing
        }
        this.activeStep = res;
        this.incompleteStep = res;
      },
      editView(view) {
        this.activeStep = view;
      },
      editDone() {
        this.activeStep = this.incompleteStep;
      },
      routeLogin() {
        this.$emit('login');
      },
    },
  };
</script>




// WEBPACK FOOTER //
// Steps.vue?0100b6b4